import { getApiSpecMetadata } from "../../_metadata/ApiSpec";
import { getEntityPropertyMetadata } from "../../_metadata/PropertyInfoMap";
import type { BacklogApiSpec } from "../../contracts/utils/metadata/BacklogApiSpec";
import type { BacklogEntityMetadata } from "../../contracts/utils/metadata/BacklogEntityMetadata";
import type { BacklogMetadata as BacklogMetadataContract } from "../../contracts/utils/metadata/BacklogMetadata";
import type { MetaTypeKey } from "../../contracts/utils/metadata/MetaTypeKey";
import type { RequestMethod } from "../../types/RequestMethod";
import { BacklogApiSpec as BacklogApiSpecImpl } from "./BacklogApiSpec";
import { BacklogEntityMetadata as BacklogEntityMetadataImpl } from "./BacklogEntityMetadata";
import { MetaTypeKey as MetaTypeKeyImpl } from "./MetaTypeKey";

export class BacklogMetadata<T> implements BacklogMetadataContract<T> {
	getEntityMetadata(key: MetaTypeKey<T>): BacklogEntityMetadata<T> {
		const meta = getEntityPropertyMetadata();
		const prop = meta.getEntityProperty(key.getMetaDataPath());
		if (!prop) {
			return this.createEmptyEntityMetadata(key);
		}
		const type_info_list = meta.createMetadataTypeInfo(prop.type_info_list);
		return new BacklogEntityMetadataImpl(key, prop.type_name, type_info_list);
	}

	createEmptyEntityMetadata(key?: MetaTypeKey<T>): BacklogEntityMetadata<T> {
		return new BacklogEntityMetadataImpl(
			key ?? new MetaTypeKeyImpl<T>(""),
			"",
			[],
		);
	}

	getApiSpec(
		endpoint: string,
		method: RequestMethod,
	): BacklogApiSpec<T> | undefined {
		const meta = getApiSpecMetadata();

		const spec = meta.getApiSpec(endpoint, method);
		if (!spec) {
			return undefined;
		}
		const api_spec_info = meta.createMetadataApiSpecInfo(spec);
		return new BacklogApiSpecImpl(api_spec_info);
	}
}
